import { useCallback, useState } from 'react';

import { useGraphQLMutation } from '@betterment/graphql';
import { useNotifications } from '@betterment/shared-components';
import { useNavigate } from 'react-router-dom';

import { isSuccessResponse } from '../data';
import { CreateBulkFeeIntentDocument } from '../graphql/mutation.createBulkFeeIntent.generated';

export function useSubmitHandler() {
  const navigate = useNavigate();
  const [createBulkFeeIntent, { loading }] = useGraphQLMutation(CreateBulkFeeIntentDocument);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const { setNotification } = useNotifications();

  const submitHandler = useCallback(
    async (bulkFeeAttemptId: string, bulkFeeAttemptName: string) => {
      const successMessage = `${bulkFeeAttemptName} has been submitted.`;
      try {
        setErrorMessage(null);

        const fetchResult = await createBulkFeeIntent({
          variables: {
            input: {
              bulkFeeAttemptId,
            },
          },
        });

        const response = fetchResult.data?.createBulkFeeIntent;

        if (!response) {
          setErrorMessage('An unexpected error occurred while submitting the fees.');
          return;
        }

        if (isSuccessResponse(response)) {
          setNotification({ type: 'success', message: successMessage });
          void navigate('/client_billing/on_demand_billing');
        } else {
          const errorMessages = response.displayableErrors.map(error => error.message).join(' ');
          setErrorMessage(errorMessages);
        }
      } catch (_) {
        setErrorMessage(`An unexpected error occurred while submitting the fees.`);
      }
    },
    [navigate, setNotification, createBulkFeeIntent, setErrorMessage]
  );

  return {
    errorMessage,
    submitHandler,
    isSubmitting: loading,
  };
}
